<template>
  <div class="section">
    <div class="container">
      <div class="level">
        <Header class="level-left" v-bind="$route.meta" />
      </div>
      <div class="columns">
        <div class="column">
          <b-field grouped>
            <b-field v-if="user.group.plants && user.group.plants.length != 0" label="Plant">
              <b-select v-model="selectedPlant" icon="industry" expanded>
                <option v-for="plant in user.group.plants" :key="plant.id" :value="plant">
                  {{ plant.name }}
                </option>
              </b-select>
            </b-field>
            <b-field v-else label="Plant">
              <multiselect
                v-model="selectedPlant"
                :options="plants"
                :multiple="false"
                :close-on-select="true"
                placeholder="Pick plant"
                :custom-label="(obj) => obj.id + ' - ' + obj.name"
                track-by="name"
                style="min-width: 400px;"
              />
            </b-field>
          </b-field>
          <b-field>
            <b-button
              class="left-right"
              type="is-warning"
              icon-left="arrows-rotate"
              :disabled="isLoading || selectedPlant === null"
              @click="() => {resetData(); getData();}"
            >
              Load
            </b-button>
          </b-field>
          <b-field label="Hourly productivity targets" grouped>
            <b-field label="Manual washing target">
              <b-input v-model="bonus.hourly_washing" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Machine washing target">
              <b-input v-model="bonus.hourly_machinewash" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Crate repair target">
              <b-input v-model="bonus.hourly_repair" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Door repair target">
              <b-input v-model="bonus.hourly_repair_door" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Minimum Production Percentage">
              <b-input v-model="bonus.under_production_target" type="number" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Forklift target">
              <b-input v-model="bonus.forklift_target" type="number" :disabled="isLoading || !isLoaded" />
            </b-field>
          </b-field>
          <b-field label="Bonus amounts" grouped>
            <b-field label="Attendance bonus">
              <b-input v-model="bonus.attendance_amount" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Production + Quality bonus">
              <b-input v-model="bonus.all_targets_amount" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Production - Quality bonus">
              <b-input v-model="bonus.prod_target_amount" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Minimum + Quality bonus">
              <b-input v-model="bonus.nc_target_amount" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Minimum - Quality bonus">
              <b-input v-model="bonus.under_production_amount" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
          </b-field>
          <b-field label="Other targets" grouped>
            <b-field label="Quality control frequency target">
              <b-input v-model="bonus.control_frequency_target" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
          </b-field>
          <b-button
            type="is-success"
            icon-left="save"
            :disabled="isLoading || !isLoaded"
            @click="() => {saveBonus();}"
          >
            Save
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Plant from '../../services/v2/plant'
import BonusManagement from '../../services/v3/bonus'
// import sortAndFilterMixins from '@/mixins/agGridSortAndFilter'

export default {
  name: 'BonusManagement',
  components: {
  },
  data: function () {
    return {
      selectedPlant: JSON.parse(sessionStorage.getItem('consultingPlant')),
      isLoading: false,
      isLoaded: false,
      storedPlantId: null,
      plants: [],
      bonus: {
        hourly_washing: 0,
        hourly_machinewash: 0,
        hourly_repair: 0,
        hourly_repair_door: 0,
        forklift_target: 0,
        attendance_amount: 0,
        all_targets_amount: 0,
        prod_target_amount: 0,
        nc_target_amount: 0,
        under_production_amount: 0,
        under_production_target: 0,
        control_frequency_target: 0
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  mounted: async function () {
    if (this.user.group.plants.length === 0) {
      this.plants = await Plant.getAll()
    }
  },
  methods: {
    resetData () {
      this.storedPlantId = null
      this.bonus = {
        hourly_washing: 0,
        hourly_machinewash: 0,
        hourly_repair: 0,
        hourly_repair_door: 0,
        forklift_target: 0,
        attendance_amount: 0,
        all_targets_amount: 0,
        prod_target_amount: 0,
        nc_target_amount: 0,
        under_production_amount: 0,
        under_production_target: 0,
        control_frequency_target: 0
      }
    },
    async getData () {
      if (!this.selectedPlant || !this.selectedPlant.id) {
        this.$buefy.toast.open({ message: 'Please select a plant', duration: 3000, type: 'is-danger' })
        return
      }
      sessionStorage.setItem('consultingPlant', JSON.stringify(this.selectedPlant))
      this.isLoading = true
      try {
        const data = await BonusManagement.get({
          siteId: this.selectedPlant.id
        })
        if (data.length > 0) {
          this.bonus = {
            id: data[0].id,
            siteId: this.selectedPlant.id,
            hourly_washing: data[0].hourly_washing,
            hourly_machinewash: data[0].hourly_machinewash,
            hourly_repair: data[0].hourly_repair,
            hourly_repair_door: data[0].hourly_repair_door,
            forklift_target: data[0].forklift_target,
            attendance_amount: data[0].attendance_amount,
            all_targets_amount: data[0].all_targets_amount,
            prod_target_amount: data[0].prod_target_amount,
            nc_target_amount: data[0].nc_target_amount,
            under_production_amount: data[0].under_production_amount,
            under_production_target: data[0].under_production_target,
            control_frequency_target: data[0].control_frequency_target
          }
          this.$buefy.toast.open({ message: 'Data loaded', duration: 3000, type: 'is-success' })
        } else {
          this.bonus = {
            siteId: this.selectedPlant.id,
            hourly_washing: 0,
            hourly_machinewash: 0,
            hourly_repair: 0,
            hourly_repair_door: 0,
            forklift_target: 0,
            attendance_amount: 0,
            all_targets_amount: 0,
            prod_target_amount: 0,
            nc_target_amount: 0,
            under_production_amount: 0,
            under_production_target: 0,
            control_frequency_target: 0
          }
          this.$buefy.toast.open({ message: 'No Data found', duration: 3000, type: 'is-danger' })
        }
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
        this.isLoading = false
      }
      this.storedPlantId = this.selectedPlant.id
      this.isLoaded = true
      this.isLoading = false
    },
    async saveBonus () {
      try {
        await BonusManagement.saveBonus(this.bonus)
        this.$buefy.toast.open({ message: 'Saved', duration: 3000, type: 'is-success' })
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
    }
  }
}

</script>
